export const name = 'PlatformAspect'
export const dispatchName = 'PlatformMessageDispatch'
export const apiCallsHandlerName = 'apiCallsHandler'
export const handleName = 'PlatformMessageHandle'
